/**
 * created by lei lei
 * 上传文件
 */
import React, {Component} from 'react';
import {Modal, Button, Table, Icon, Input, Progress, message} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import UploadWall from "../../../../components/upload/UploadWall";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import {FILE_TYPE, VIDEO_TYPE} from "../../../../constants";
import BaseComponent from "../../../../base/BaseComponent";
import {uuid} from "../../../../utils";

const {Search} = Input;

let fileType = ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'rm', 'rmvb', 'wmv', 'avi', 'asf', 'mpg', 'mpeg', 'flv', 'mp4', 'mov', 'mp3', 'mp2', 'wav', 'mid', 'midi', 'ra', 'doc', 'docx', 'ppt', 'pptx', 'pps', 'ppsx', 'xls', 'xlsx', 'pdf', 'eot', 'woff', 'svg', 'ttf', 'otf', 'zip', 'rar', 'swf', 'wps', 'dps', 'et', 'apk'];
fileType = [...fileType, ...fileType.toUpperCase()]
export default class UploadFiles extends BaseComponent {

    static defaultProps = {
        onCancelCall: ()=>{},
        onOkCall: ()=>{},
    };

    constructor(props) {
        super(props);
        this.state = {
            fileNumber:'',
            columns: [],
            fileList: [],
            maxFileList: this.sysConfigGetValueByKey("Upload.max.fileList", "10")*1,
            maxFileSize: this.sysConfigGetValueByKey("Upload.max.fileSize", "100")*1,
        };
        this.chunkUpload = new ChunkUpload({
            checkFileURL:"/storage/checkFile",
            checkChunkURL:"/storage/checkChunk",
            uploadChunkURL:"/storage/uploadChunk",
            chunkUploadOverURL:"/storage/chunkIsUploadOver",
            mergeChunksURL:"/storage/mergeChunk"
        });
    }

    componentDidMount() {
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.state.fileList = nextProps.attach;
    }

    // 初始化数据
    initData = () => {
    };

    render() {
        const {uploadVisible, onCancelCall, onOkCall, queryStr,attach} = this.props;
        const columns = [
            {
                title: "文件名",
                dataIndex: "name",
                key: "name",
                ellipsis: true
            },
            {
                title: "进度",
                width:150,
                dataIndex: "percent",
                key: "percent",
                render: (text, record, index) =>{
                    const errorColor = "#f56c6c";
                    const { status } = record;
                    const isError = status === "error";
                    let isOver = status === "done";
                    if(!record.uid){//说明是文件是上传过了的，现在回显
                        isOver = true;
                    }
                    return <Progress
                        strokeColor={isError ? errorColor : this.themeBgColor}
                        status={isError ? "exception" : isOver ? "success" : "active"}
                        percent={record.url?100:parseInt(record.percent)}
                        format={percent => {
                            if(isError){
                                return <Icon type="close-circle" />;
                            }
                            if(percent === 100){
                                if(!isOver){
                                    return "处理中";
                                }else{
                                    return <Icon type="check-circle" />;
                                }
                            }
                            return percent + '%';
                        }}
                    />
                }
            },
            {
                title: "操作",
                width:100,
                align:"center",
                key: "status",
                render: (text, record, index) =>
                    <div>
                        <Button type={'link'} onClick={() => {
                            this.handleRemove(record);
                            this.chunkUpload.cancelUpload(record);
                        }}
                        >删除</Button>
                    </div>
            }
        ];
        return (
            <Modal
                title="上传文件"
                visible={uploadVisible}
                onOk={this.onOk}
                width={800}
                onCancel={this.onCancel}
            >
                <div style={{
                    display: 'flex',
                    marginBottom: 10,
                }}>
                    <UploadWall
                        // accept={`.${FILE_TYPE.join(",.")}`}
                        accept={"."+fileType.join(",.")}
                        multiple={true}
                        action="/storage/uploadFile"
                        listType={'list'}
                        fileList={attach}
                        style={{padding:'unset'}}
                        customRequest={this.chunkUpload.start}
                        uploadBtnName={<Button type="primary">上传文件</Button>}
                        beforeUpload={this.beforeUpload}
                        onChange={this.onChange}
                        onRemove={this.handleRemove}
                        onPreview={this.handlePreview}
                        showPercent={false}
                    />
                </div>
                <Scrollbars style={{height:220}}>
                    <Table dataSource={attach} columns={columns} pagination={false}/>
                </Scrollbars>
            </Modal>
        );
    }

    messageKey;
    throttleTime = 0;
    onOk = () => {
        // let newTime = Date.now();
        // if(newTime - this.throttleTime < 500) {
        //     message.warn("请勿重复快速点击按钮");
        //     return;
        // }
        // this.throttleTime = newTime;
        message.destroy();
        if(!this.messageKey){
            this.messageKey = "a" + uuid();
        }
        const {fileList}=this.state;
        for(let i = 0 ; fileList && i < fileList.length; i++){
            let item = fileList[i];
            if(item.uid){//说明是刚上传的
                if(item.status!="done"){
                    message.warn({key:this.messageKey, content: `${item.name}尚未上传完成`});
                    return;
                }
            }
        }
        if(typeof this.props.onOkCall == 'function') {
            let newFileList = fileList && fileList.length && fileList.map(item => ({
                "md5": item.md5,
                "name": item.name,
                "url": item.url,
                "smallPath": item.smallPath,
                "ext": item.ext,
            }));
            this.props.onOkCall(newFileList);
        }
        this.onCancel();
    };

    onCancel = () => {
        if(!this.messageKey){
            this.messageKey = "a" + uuid();
        }
        const {fileList}=this.state;
        let activeFileList = [];
        let overFileList = [];
        for(let i = 0 ; fileList && i < fileList.length; i++){
            let item = fileList[i];
            if(item.uid){//说明是刚上传的
                if(item.status!="done"){
                    activeFileList.push(item);
                    continue;
                }
            }
            overFileList.push(item);
        }

        let fun = ()=>{
            if(typeof this.props.onCancelCall == 'function') {
                let newFileList = overFileList.map(item=>({
                    "md5": item.md5,
                    "name": item.name,
                    "url": item.url,
                    "smallPath": item.smallPath,
                    "ext": item.ext,
                }));
                this.props.onCancelCall(newFileList);
            }
        };
        if(activeFileList.length > 0){
            Modal.confirm({
                title: '存在未上传完成的文件',
                content: `${activeFileList.map(item=>item.name).join("、")}未上传完成，是否中断上传？`,
                okText: '确认',
                cancelText: '取消',
                onOk:()=>{
                    for(let i = 0 ; fileList && i < fileList.length; i++){
                        let item = fileList[i];
                        if(item.uid){//说明是刚上传的
                            if(item.status!="done"){
                                this.chunkUpload.cancelUpload(item);
                                continue;
                            }
                        }
                    }
                    fun();
                }
            });
        }else{
            fun();
        }
    };
    onChange = (info) => {
        if(info.fileList && info.fileList.length > this.state.maxFileList){
            info.fileList.splice(this.state.maxFileList,info.fileList.length)
            message.destroy()
            message.error(`文件数量不能超过${this.state.maxFileList}个！`);
        }
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                item.uid = info.file.uid;
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                if(info.file.response){
                    item.ext = info.file.response && info.file.response.suffix;
                    item.url = info.file.response && info.file.response.path;
                    item.smallPath = info.file.response && info.file.response.smallPath;
                    item.name = item.name || info.file.name || (info.file.response && info.file.response.name);
                    item.md5 = info.file.response && info.file.response.md5;
                }
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        let newFileList = info.fileList;
        this.props.onChange(JSON.parse(JSON.stringify(newFileList)));
        this.setState({
            fileList: info.fileList
        })
    };

    beforeUpload = async file => {



        let data = fileType.find(item => file.name.endsWith(item));
        let sizeValue =  file.size / 1024 / 1024;
        return new Promise((resolve, reject) => {
            if(file.size === 0){
              
                message.error('空文件不能上传！');
                reject();
            }
            if (data) {
                if (sizeValue < this.state.maxFileSize) {
                    if (this.state.fileList && this.state.fileList.length && this.state.fileList.length > 0) {
                        this.chunkUpload.getFileMd5(file, ({originalMd5}) => {
                            let res = this.state.fileList.find(item => {
                                if (item.md5 === originalMd5 || item.originalMd5 === originalMd5) {
                                    return true;
                                }
                                return item.xhr && item.xhr.originalMd5 === originalMd5;
                            });

                            if (res) {
                                message.error("文件已在列表中！");
                                reject();
                            } else {
                                resolve();
                            }
                        });
                    } else {
                        resolve();
                    }
                } else {
                    message.error(`文件大小不能超过${this.state.maxFileSize}MB！`);
                    reject();
                }
            }else{
                message.error(`文件格式不正确！`);
                reject();
            }
        });
    };
    // beforeUploadFile = async file => {
    //     let res = fileType.find(item => file.name.endsWith(item));
    //     return new Promise((resolve, reject) => {
    //         if (res) {
    //             resolve(file);
    //         } else {
    //             message.error(`图片格式不正确，只能上传以下图片格式：${fileType.join("，")}`);
    //             reject();
    //         }
    //     });
    // };


    handleRemove =  file => {
        let fileList = this.state.fileList.filter(item => {
            if(item.uid && file.uid){
                return item.uid !== file.uid
            }
            return item.md5 !== file.md5;
        });
        this.props.onChange(JSON.parse(JSON.stringify(fileList)));
        this.setState({
            fileList
        });
    };

    handlePreview = file => {
        if(file && file.url){
            this.setState({
                previewImage: file.url,
                previewVisible: true,
            });
        }
    };


}